import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
import { computed } from "vue";
import { clone } from "lodash-es";
import AppShowEntryClassChip from "./AppShowEntryClassChip.vue";
import { useCompetitionHelpers } from "@/composables/competition_helpers";
import gql from "fraql";
const __default__ = {
    name: "AppShowEntryCompetitionDetails",
    fragments: {
        entryFields: gql `
      fragment _ on Entry {
        ${AppShowEntryClassChip.fragments.entryFields}
        icelandicDirection
        sectionId
        section @client {
          id
          shortName
        }
      }
    `,
        competitionFields: gql `
      fragment _ on Competition {
        id
        code
        name
        startDate
        competitionLevelId
        competitionLevel @client {
          id
          name
        }
        difficultyLevelId
        difficultyLevel @client {
          id
          displayName
        }
        competitionRuleId
        competitionRule @client {
          id
          name
        }
      }
    `
    }
};
export default /*@__PURE__*/ _defineComponent({
    ...__default__,
    props: {
        entries: {
            type: Array,
            default: null
        },
        doNotShowCode: {
            type: Boolean,
            default: false
        }
    },
    setup(__props) {
        const props = __props;
        const { competitionOrderFn } = useCompetitionHelpers();
        const sortedEntries = computed(() => {
            return clone(props.entries).sort((a, b) => competitionOrderFn.value(a.competition.code, b.competition.code));
        });
        function details(competition) {
            let ds = [
                competition.name,
                competition.competitionLevel?.name,
                competition.difficultyLevel?.displayName,
                competition.competitionRule?.name
            ]
                .filter(Boolean)
                .join(" | ");
            if (competition.startDate && ds) {
                ds = " | " + ds;
            }
            return ds;
        }
        return (_ctx, _cache) => {
            return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedEntries.value, (entry) => {
                return (_openBlock(), _createElementBlock("div", _mergeProps({
                    key: entry.id,
                    ref_for: true
                }, _ctx.$attrs), [
                    (!__props.doNotShowCode)
                        ? (_openBlock(), _createBlock(AppShowEntryClassChip, {
                            key: 0,
                            entry: entry
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(entry.competition.code) + " " + _toDisplayString(entry.section ? ` (${entry.section.shortName})` : "") + " " + _toDisplayString(entry.icelandicDirection ? ` - ${entry.icelandicDirection}` : ""), 1)
                            ]),
                            _: 2
                        }, 1032, ["entry"]))
                        : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.$dayjs.date(entry.competition.startDate)) + " " + _toDisplayString(details(entry.competition)), 1)
                ], 16));
            }), 128));
        };
    }
});
